import React from "react";
import moment from "moment";
import Chart from "react-apexcharts";

const DailyRangeDeposits = ({ deposits, depositsCounts, payments }) => (
    <div>
        <Chart
            options={{
                title: {
                    text: "Deposits",
                    align: "left"
                },
                chart: {
                    id: "daily-range-deposits-bar",
                    toolbar: {
                        show: true
                    },
                    zoom: {
                        enabled: true,
                        type: "x",
                        autoScaleYaxis: false,
                        zoomedArea: {
                            fill: {
                                color: "#90CAF9",
                                opacity: 0.4
                            },
                            stroke: {
                                color: "#0D47A1",
                                opacity: 0.4,
                                width: 1
                            }
                        }
                    }
                },
                plotOptions: {
                    bar: {
                        columnWidth: "50%",
                        endingShape: "arrow"
                    }
                },
                stroke: {
                    curve: "smooth"
                },
                xaxis: {
                    categories: Object
                        .keys(deposits)
                        .map(timestamp => moment(parseInt(timestamp, 10))
                            .format("YYYY-MM-DD")),
                    type: "datetime",
                    labels: {
                        format: "dd MMM (ddd)"
                    }
                },
                markers: {
                    size: 6,
                    strokeWidth: 3,
                    fillOpacity: 0,
                    strokeOpacity: 0,
                    hover: {
                        size: 8
                    }
                },
            }}
            series={[{
                name: "Card",
                data: Object.keys(deposits)
                    .map(day => deposits[day].card)
            }, {
                name: "Idram",
                data: Object.keys(deposits)
                    .map(day => deposits[day].depositIdram)
            }, {
                name: "Idram Terminal",
                data: Object.keys(deposits)
                    .map(day => deposits[day].depositIdramTerminal)
            }, {
                name: "Pay With Telcell",
                data: Object.keys(deposits)
                    .map(day => deposits[day].depositPayWithTelcell)
            }, {
                name: "Telcell",
                data: Object.keys(deposits)
                    .map(day => deposits[day].depositTelcell)
            }, {
                name: "FastShift",
                data: Object.keys(deposits)
                    .map(day => deposits[day].depositFastshift)
            }]}
            type="line"
            width="100%"
            height={240}
        />
        <Chart
            options={{
                title: {
                    text: "Deposit Amount/Count",
                    align: "left"
                },
                chart: {
                    id: "daily-range-depositsCounts-bar",
                    toolbar: {
                        show: true
                    },
                    zoom: {
                        enabled: true,
                        type: "x",
                        autoScaleYaxis: false,
                        zoomedArea: {
                            fill: {
                                color: "#90CAF9",
                                opacity: 0.4
                            },
                            stroke: {
                                color: "#0D47A1",
                                opacity: 0.4,
                                width: 1
                            }
                        }
                    }
                },
                plotOptions: {
                    bar: {
                        columnWidth: "50%",
                        endingShape: "arrow"
                    }
                },
                stroke: {
                    curve: "smooth"
                },
                xaxis: {
                    categories: Object
                        .keys(depositsCounts)
                        .map(timestamp => moment(parseInt(timestamp, 10))
                            .format("YYYY-MM-DD")),
                    type: "datetime",
                    labels: {
                        format: "dd MMM (ddd)"
                    }
                },
                markers: {
                    size: 6,
                    strokeWidth: 3,
                    fillOpacity: 0,
                    strokeOpacity: 0,
                    hover: {
                        size: 8
                    }
                },
            }}
            series={[{
                name: "Amount",
                data: Object.keys(depositsCounts)
                    .map(day => depositsCounts[day].depositAmount)
            }, {
                name: "Count",
                data: Object.keys(depositsCounts)
                    .map(day => depositsCounts[day].depositCount)
            }]}
            type="line"
            width="100%"
            height={240}
        />
        <Chart
            options={{
                title: {
                    text: "Payments Amount/Count",
                    align: "left"
                },
                chart: {
                    id: "daily-range-payments-bar",
                    toolbar: {
                        show: true
                    },
                    zoom: {
                        enabled: true,
                        type: "x",
                        autoScaleYaxis: false,
                        zoomedArea: {
                            fill: {
                                color: "#90CAF9",
                                opacity: 0.4
                            },
                            stroke: {
                                color: "#0D47A1",
                                opacity: 0.4,
                                width: 1
                            }
                        }
                    }
                },
                plotOptions: {
                    bar: {
                        columnWidth: "50%",
                        endingShape: "arrow"
                    }
                },
                stroke: {
                    curve: "smooth"
                },
                xaxis: {
                    categories: Object
                        .keys(payments)
                        .map(timestamp => moment(parseInt(timestamp, 10))
                            .format("YYYY-MM-DD")),
                    type: "datetime",
                    labels: {
                        format: "dd MMM (ddd)"
                    }
                },
                markers: {
                    size: 6,
                    strokeWidth: 3,
                    fillOpacity: 0,
                    strokeOpacity: 0,
                    hover: {
                        size: 8
                    }
                },
            }}
            series={[{
                name: "Amount",
                data: Object.keys(payments)
                    .map(day => payments[day].paymentAmount)
            }, {
                name: "Count",
                data: Object.keys(payments)
                    .map(day => payments[day].paymentCount)
            }]}
            type="line"
            width="100%"
            height={240}
        />
    </div>
);

export default DailyRangeDeposits;



// WEBPACK FOOTER //
// ./src/views/pages/reports/daily-range-deposits.js